
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rotate-image",
      function () {
        return require("private-next-pages/rotate-image/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rotate-image"])
      });
    }
  